// extracted by mini-css-extract-plugin
module.exports = {"lineHeight":"1.6","fontSize":"15px","fontWeight":"300","fontFamily":"Biotif, Helvetica, Arial, sans-serif","color":"#181818"};